import { Component } from '@angular/core';

@Component({
  selector: 'report-layout',
  templateUrl: './report-layout.component.html'
})
export class  ReportLayoutComponent {
  
}
